import React from "react";
import { motion } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ActionButton } from "../common/ActionButton";
import {
  faCalendarAlt,
  faMapMarkerAlt,
} from "@fortawesome/free-solid-svg-icons";

export const SectionDate = () => {
  return (
    <section id="date" className="w-full py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6">
        {/* Mobile: Title — TETAP SAMA */}
        <div className="md:hidden text-center">
          <motion.h2
            className="text-2xl font-black uppercase tracking-wider text-gray-800"
            initial={{ opacity: 0, y: -15 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
          >
            SEATRC 2026
          </motion.h2>
          <motion.h3
            className="text-4xl font-black text-gray-800 mt-2 mb-6"
            initial={{ opacity: 0, y: -15 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2, ease: "easeOut" }}
          >
            WELCOME
          </motion.h3>
        </div>

        {/* Mobile: Description — sudah diperbarui */}
        <div className="md:hidden text-center">
          <motion.p
            className="text-base text-gray-600 mb-6 leading-relaxed"
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.2, ease: "easeOut" }}
            viewport={{ once: true }}
          >
            The Southeast Asian Trail Running Cup (SEATRC) 2026 is proudly hosted
            in Indonesia. This prestigious championship gathers the finest
            national team athletes from across the region to compete at the
            magnificent TNGGP-Cibodas in West Java.
          </motion.p>
        </div>

        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col md:grid md:grid-cols-2 gap-4 md:gap-12">
            {/* Left Column — TETAP PAKAI TITLE ASLI */}
            <div className="space-y-4 md:space-y-8 order-3 md:order-1">
              {/* Desktop: Title — TIDAK DIUBAH */}
              <div className="hidden md:block text-center md:text-left">
                <motion.h2
                  className="text-2xl font-black uppercase tracking-wider text-gray-800"
                  initial={{ opacity: 0, y: -15 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, ease: "easeOut" }}
                >
                  SEATRC 2026
                </motion.h2>
                <motion.h3
                  className="text-5xl md:text-6xl font-black text-gray-800 mt-2"
                  initial={{ opacity: 0, y: -15 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: 0.2, ease: "easeOut" }}
                >
                  WELCOME
                </motion.h3>
              </div>

              {/* Desktop: Description — sudah diperbarui */}
              <motion.p
                className="hidden md:block text-base md:text-lg text-gray-600 leading-relaxed text-center md:text-left"
                initial={{ opacity: 0, y: 10 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, delay: 0.2, ease: "easeOut" }}
                viewport={{ once: true }}
              >
            The Southeast Asian Trail Running Cup (SEATRC) 2026 is proudly hosted
            in Indonesia. This prestigious championship gathers the finest
            national team athletes from across the region to compete at the
            magnificent TNGGP-Cibodas in West Java.
              </motion.p>

              {/* Button */}
              <motion.div
                className="text-center md:text-left"
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, delay: 0.3, ease: "easeOut" }}
              >
                <ActionButton
                  to="/schedule"
                  variant="secondary"
                  className="uppercase"
                >
                  EVENT SCHEDULE
                </ActionButton>
              </motion.div>
            </div>

            {/* Right Column: Date & Location — sudah sesuai 2026 */}
            <div className="flex flex-col gap-6 items-center md:items-start text-center md:text-left order-2 md:order-2">
              <div className="space-y-3 bg-gray-50 border border-gray-200 rounded-xl p-6 w-full max-w-lg">
                <div className="flex items-center justify-center md:justify-start gap-3">
                  <FontAwesomeIcon
                    icon={faCalendarAlt}
                    className="text-3xl text-gray-800"
                  />
                  <p className="text-sm font-bold uppercase text-gray-500">
                    Date
                  </p>
                </div>
                <p className="text-2xl font-black text-gray-800">
                  24 - 26 July 2026
                </p>
                <p className="text-sm text-gray-600">
                  Main Race Day · Official SEATRC 2026
                </p>
                <p className="text-lg font-semibold text-gray-800 mt-3">
                  Categories: 75K · 42K · 10K · VERTICAL
                </p>
              </div>

              <div className="space-y-3 bg-gray-50 border border-gray-200 rounded-xl p-6 w-full max-w-lg">
                <div className="flex items-center justify-center md:justify-start gap-3">
                  <FontAwesomeIcon
                    icon={faMapMarkerAlt}
                    className="text-3xl text-gray-800"
                  />
                  <p className="text-sm font-bold uppercase text-gray-500">
                    Location
                  </p>
                </div>
                <p className="text-2xl font-black text-gray-800">
                  Zone 1 — Pasar Wisata Cibodas
                </p>
                <p className="text-sm text-gray-600 leading-relaxed">
                  Official venue for JOTR SEATRC Cianjur Series 2026.
                </p>
                <a
                  href="https://www.google.com/maps/place/6%C2%B043'59.9%22S+107%C2%B000'32.6%22E/@-6.733302,107.009047,17z/data=!3m1!4b1!4m4!3m3!8m2!3d-6.733302!4d107.009047!18m1!1e1?entry=ttu&g_ep=EgoyMDI2MDcyMC4wIKXMDSoASAFQAw%3D%3D"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block text-sm font-bold text-gray-800 hover:text-gray-600"
                >
                  View on Google Maps &rarr;
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
